import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const displayedFeatureCodes = ['material', 'lining', 'fastening', 'sole', 'technology'];

const ProductFeatures = ({ assignedFeatures }) => {
  const intl = useIntl();
  const materialDisplayName = intl.formatMessage({
    id: `products.pdp.features.upper.label`,
  });

  return (
    <Fragment>
      {displayedFeatureCodes
        .filter(code => !!assignedFeatures[code])
        .map(code => (
          <li className="feature" key={code}>
            <span className="feature__name no-wrap">
              {code === 'material' ? materialDisplayName : assignedFeatures[code].name}:
            </span>
            <span className="feature__value">{assignedFeatures[code].value}</span>
          </li>
        ))}
    </Fragment>
  );
};

ProductFeatures.propTypes = {
  assignedFeatures: PropTypes.objectOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
};

const mapStateToProps = ({ detailsPage }) => ({
  assignedFeatures: detailsPage.loadedProduct.classifications
    .filter(classification => classification.code === 'footwear')
    .map(classification => classification.features)[0]
    .filter(feature => displayedFeatureCodes.includes(feature.featureCode))
    .reduce(
      (acc, next) => ({
        ...acc,
        [next.featureCode]: {
          name: next.name,
          value: next.featureValues[0].value,
        },
      }),
      {}
    ),
});

export default connect(mapStateToProps)(ProductFeatures);
